import { render, staticRenderFns } from "./ThreePartShow.vue?vue&type=template&id=efeda400&scoped=true"
import script from "./ThreePartShow.vue?vue&type=script&lang=js"
export * from "./ThreePartShow.vue?vue&type=script&lang=js"
import style0 from "./ThreePartShow.vue?vue&type=style&index=0&id=efeda400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeda400",
  null
  
)

export default component.exports